'use strict';

export class Tasks {
	constructor () {
		this.tasks = [];
	}
	
	addTask(task) {
		this.tasks.push(task);
	}
	
	run() {
		if (this.tasks.length) {
			const started = this.tasks.every(task => task.isStarted());
			if (started) {
				this.tasks = [];
			} else {
				this.tasks.forEach(task => task.start());
				setTimeout(this.run.bind(this),300);
			}
		}
	}
}


export class UpdateTask {
	constructor (func) {
		this.started = false;
		this.onStart = func;
	}
	
	start() {
		if (this.onStart) {
			this.onStart();
		}
		this.started = true;
	}
	
	isStarted() {
		return this.started;
	}
}

